import script from "./TradingView.vue?vue&type=script&setup=true&lang=js"
export * from "./TradingView.vue?vue&type=script&setup=true&lang=js"

import "./TradingView.vue?vue&type=style&index=0&id=701a8935&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-701a8935"]])

export default __exports__